
{
  "fr": {
    "mandat": "Mandat",
    "administratif": "administratif"
  }
}
